import moment from "moment";
import {customAlphabet} from "nanoid";

import {showErrorOnSave} from "../../FeaturesSetup/featuresAsyncActions";
import {updateJob} from "../JobBoardActions";
import {getParsedJobOrder, getReferralAmount} from "./jobOrderFunctions";
import {PURCHASE_ORDER_CONTENT} from "./jobPurchaseOrderReducer";
import {uploadJobFileRequest} from "../../../actions/A_Calendar";
import {setJobPurchaseOrderErrorMessage, setJobPurchaseOrderInvoiceFile} from "./jobPurchaseOrderActions";
import {JOB_DOCUMENT_TYPES} from "../../../utilities/constants";
import {loadingDialog_show} from "../../../actions";
import {updateRelatedJobsNotificationsCount} from "../../../actions/dashboardFunctions";

const nanoid = customAlphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", 10);


export const updateJobOrder = (updatedJobOrder = null) => {
  return async (dispatch, getState) => {

    const store = getState();
    const {job, jobTotal} = store.jobEditPopupState;
    const {purchaseOrderStep, purchaseOrderInvoiceNumber, purchaseOrderInvoiceFile} = store.jobPurchaseOrderPopupState;

    try {
      const jobOrder = updatedJobOrder || getParsedJobOrder(job); // jobOrderInterface

      switch (purchaseOrderStep) {
        case PURCHASE_ORDER_CONTENT.purchaseOrder:
          jobOrder.orderId = nanoid(); // Generates a short unique ID (e.g., "YgXzPQE92A");
          jobOrder.orderCreatedAt = moment.utc().valueOf(); // timestamp utc
          jobOrder.referralAmount = getReferralAmount(jobOrder, jobTotal);
          jobOrder.qcAmount = getReferralAmount(jobOrder, jobTotal, "qcPercent");
          jobOrder.orderTotal = jobTotal.totalWithTaxes;
          // getJobReferrerReceipt(); // doesnt work :( we are using iframe
          break;
        case PURCHASE_ORDER_CONTENT.purchaseOrderInvoice:
          const responseUploadJobFile = await uploadJobFileRequest(purchaseOrderInvoiceFile, job, JOB_DOCUMENT_TYPES.invoice);
          if (responseUploadJobFile.downloadUrl) {
            jobOrder.invoiceFileUrl = responseUploadJobFile.downloadUrl;
          }
          jobOrder.invoiceCreatedAt = moment.utc().valueOf(); // timestamp utc;
          jobOrder.invoiceId = purchaseOrderInvoiceNumber;
          dispatch(updateRelatedJobsNotificationsCount()); // update top red notification
          break;
        case PURCHASE_ORDER_CONTENT.purchaseOrderPay:
          if (!jobOrder.referralAmount) { //just in case
            dispatch(setJobPurchaseOrderErrorMessage("Error, no payment amount"));
            return false
          }
          const responsePaid = await payJobACHPayment(job, jobOrder);
          console.log("responsePaid", responsePaid);
          if (responsePaid && !responsePaid.__error__ && !responsePaid.errorMessage) {
            jobOrder.isPaid = true;
          } else if (responsePaid && (responsePaid.__error__ || responsePaid.errorMessage)) {
            dispatch(setJobPurchaseOrderErrorMessage(
              responsePaid.errorMessage || responsePaid.__errorMessage__ || "An error occurred"
            ))
          }
          break;
        default:
          break;
      }

      console.log("new jobOrder", jobOrder);

      // update back & front
      await getApiConfig(`JobBoard/updateJobOrder/${job.id}`).post(JSON.stringify(jobOrder));
      dispatch(updateJob(job, {
        jobOrder: JSON.stringify(jobOrder),
      }));
      return true
    } catch (response) {
      console.log('error updateJobOrder ->', response);
      // dispatch(loadingDialog_show(false));
      // showErrorOnSave(dispatch, response, intl);
      dispatch(setJobPurchaseOrderErrorMessage(response.error || response.__error__ || response + "" || "An error occurred"))
      return false
    }
  }
}

export const payJobACHPayment = (job, jobOrder) => {
  const QCAmount = jobOrder.qcAmount || 0;
  const totalToCharge = jobOrder.referralAmount + QCAmount;
  const Amount = Math.round(totalToCharge * 100) / 100;
  // for example, job total is 1001, 200.2(20%) + 100.1(10%) = 300.29999999999995 -> we are rounding it to 300.30
  return getApiConfig('JobBoard/' + job.id + '/pay').post({
    Amount,
    FromFabricatorId: jobOrder.parentFabricatorId,
    ToFabricatorId: jobOrder.childFabricatorId,
    InvoiceId: jobOrder.invoiceId,
    QCAmount,
  })
}
